import React from "react";
import { Dialog, withStyles } from "@material-ui/core";

const MaterialDialog = withStyles({
  root: {
    "& .MuiDialog-paper": {
      maxWidth: "380px",
      width: "100%",
      margin: "20px"
    }
  }
})(Dialog);

export default MaterialDialog;